import { useNavigate } from "react-router-dom";
import { SwanLogo } from "@/components/Brand";
import { Home } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="swan-bg min-h-screen flex flex-col items-center justify-center text-center px-6">
      <SwanLogo size={80} />
      <div className="font-serif font-black text-[#C9A84A] text-7xl mt-8">404</div>
      <h1 className="font-serif font-bold text-white text-2xl mt-3">This page has drifted off course</h1>
      <p className="text-slate-400 mt-2 max-w-sm">
        We couldn't find the page you were looking for. Let's get you back to calmer waters.
      </p>
      <button onClick={() => navigate("/")} data-testid="notfound-home"
        className="mt-7 bg-[#C9A84A] hover:bg-[#E5C158] text-[#0A0F1F] font-bold rounded-full px-6 py-3 flex items-center gap-2 transition-colors">
        <Home size={18} /> Back to home
      </button>
    </div>
  );
}
